<template>
  <div class="aboutus-content">
    <div class="title-content">
      <div class="big-title">{{ $t("route.aboutus") }}</div>
      <div class="small-title">About us</div>
    </div>
    <div class="img-introduce-content">
      <img
        :src="aboutusData['detailsPicture1']"
        v-if="aboutusData && aboutusData['detailsPicture1']"
        alt=""
      />
      <p>{{ aboutusData["details"] }}</p>
      <img
        :src="aboutusData['detailsPicture4']"
        v-if="aboutusData && aboutusData['detailsPicture4']"
        alt=""
      />
      <img
        :src="aboutusData['detailsPicture5']"
        v-if="aboutusData && aboutusData['detailsPicture5']"
        alt=""
      />
      <img
        :src="contactusData[0].detailsPicture"
        v-if="
          contactusData[0] &&
          contactusData[0].detailsPicture &&
          $i18n.locale === 'en'
        "
        alt=""
      />
    </div>
    <div
      class="title-content"
      style="background: #f5f5f5"
    >
      <div class="big-title">{{ $t("route.contactus") }}</div>
      <div class="small-title">Contact Us</div>
    </div>
    <div class="sale-card-content">
      <div class="card-item">
        <div class="card-item-head-img">
          <img
            src="../../assets/mobile/陈军.png"
            alt=""
          />
        </div>
        <div class="card-item-head-text">
          <div class="name">
            <img
              src="../../assets/mobile/name.png"
              alt=""
            />
            <span>陈军</span>
          </div>
          <div class="phone">
            <img
              src="../../assets/mobile/phone.png"
              alt=""
            />
            <span><a href="tel:18027296402">18027296402</a></span>
          </div>
          <div class="email">
            <img
              src="../../assets/mobile/email.png"
              alt=""
            />
            <span>chenjun@uyu1027.com</span>
          </div>
        </div>
        <div class="card-item-head-code">
          <img
            src="../../assets/mobile/陈军-code.jpg"
            alt=""
          />
        </div>
      </div>
      <div class="card-item">
        <div class="card-item-head-img">
          <img
            src="../../assets/mobile/江永智.png"
            alt=""
          />
        </div>
        <div class="card-item-head-text">
          <div class="name">
            <img
              src="../../assets/mobile/name.png"
              alt=""
            />
            <span>江永智<span style="font-size: 2rem; margin-left: unset">（江浙沪及海外）</span></span>
          </div>
          <div class="phone">
            <img
              src="../../assets/mobile/phone.png"
              alt=""
            />
            <span><a href="tel:18344309099">18344309099</a></span>
          </div>
          <div class="email">
            <img
              src="../../assets/mobile/email.png"
              alt=""
            />
            <span>jiangyongzhi@uyu1027.com</span>
          </div>
        </div>
        <div class="card-item-head-code">
          <img
            src="../../assets/mobile/江永智-code.jpg"
            alt=""
          />
        </div>
      </div>
      <div class="card-item">
        <div class="card-item-head-img">
          <img
            src="../../assets/mobile/陈姣.png"
            alt=""
          />
        </div>
        <div class="card-item-head-text">
          <div class="name">
            <img
              src="../../assets/mobile/name.png"
              alt=""
            />
            <span>陈姣</span>
          </div>
          <div class="phone">
            <img
              src="../../assets/mobile/phone.png"
              alt=""
            />
            <span><a href="tel:18678140896">18678140896</a></span>
          </div>
          <div class="email">
            <img
              src="../../assets/mobile/email.png"
              alt=""
            />
            <span>chenjiao@uyu1027.com</span>
          </div>
        </div>
        <div class="card-item-head-code">
          <img
            src="../../assets/mobile/陈姣-code.jpg"
            alt=""
          />
        </div>
      </div>
      <div class="card-item">
        <div class="card-item-head-img">
          <img
            src="../../assets/mobile/李岳彪.png"
            alt=""
          />
        </div>
        <div class="card-item-head-text">
          <div class="name">
            <img
              src="../../assets/mobile/name.png"
              alt=""
            />
            <span>李岳彪</span>
          </div>
          <div class="phone">
            <img
              src="../../assets/mobile/phone.png"
              alt=""
            />
            <span><a href="tel:18011974405">18011974405</a></span>
          </div>
          <div class="email">
            <img
              src="../../assets/mobile/email.png"
              alt=""
            />
            <span>liyuebiao@uyu1027.com</span>
          </div>
        </div>
        <div class="card-item-head-code">
          <img
            src="../../assets/mobile/李岳彪-code.jpg"
            alt=""
          />
        </div>
      </div>
      <div class="card-item">
        <div class="card-item-head-img">
          <img
            src="../../assets/mobile/温广平.png"
            alt=""
          />
        </div>
        <div class="card-item-head-text">
          <div class="name">
            <img
              src="../../assets/mobile/name.png"
              alt=""
            />
            <span>温广平 </span>
          </div>
          <div class="phone">
            <img
              src="../../assets/mobile/phone.png"
              alt=""
            />
            <span><a href="tel:18011922540">18011922540</a></span>
          </div>
          <div class="email">
            <img
              src="../../assets/mobile/email.png"
              alt=""
            />
            <span>wenguangping1@uyu1027.com</span>
          </div>
        </div>
        <div class="card-item-head-code">
          <img
            src="../../assets/mobile/温广平-code.jpg"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="promotion-content">
      <div class="promotion-item">
        <div class="promotion-item-title">添加微信客服</div>
        <div class="img">
          <img
            src="../../assets/mobile/微信客服.jpg"
            alt=""
          />
        </div>
      </div>
      <div class="promotion-item">
        <div class="promotion-item-title">关注公众号</div>
        <div class="img">
          <img
            src="../../assets/mobile/公众号.jpg"
            alt=""
          />
        </div>
      </div>
      <div class="promotion-item">
        <div class="promotion-item-title">关注头条号</div>
        <div class="img">
          <img
            src="../../assets/mobile/头条号.jpg"
            alt=""
          />
        </div>
      </div>
      <div class="promotion-item">
        <div class="promotion-item-title">关注抖音号</div>
        <div class="img">
          <img
            src="../../assets/mobile/抖音号.jpg"
            alt=""
          />
        </div>
      </div>
      <div class="promotion-item radio-promotion">
        <div class="promotion-item-title">优鱼优选小程序</div>
        <div class="img">
          <img
            src="../../assets/mobile/优鱼优选.png"
            alt=""
          />
        </div>
      </div>
      <div class="promotion-item radio-promotion">
        <div class="promotion-item-title">优鱼优养小程序</div>
        <div class="img">
          <img
            src="../../assets/mobile/优鱼优养.png"
            alt=""
          />
        </div>
      </div>
      <div class="promotion-item radio-promotion">
        <div class="promotion-item-title">优鱼云控小程序</div>
        <div class="img">
          <img
            src="../../assets/mobile/优鱼云控.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="aboutus-logo">
      <img src="../../assets/mobile/logo.png" />
    </div>
    <div class="aboutus-text">
      <div class="home-phone-img-box">
        <img
          src="../../assets/mobile/HomePhone.png"
          alt=""
        />
        <span class="home-phone-text">{{ $t("home.telephone")
          }}<a
            @click="businessStatisClick()"
            style="color: white"
            href="tel:020-85532423"
          >020-85532423</a></span>
      </div>
      <span>{{ $t("home.email") }}june@uyu1027.com</span>
      <span>{{ $t("home.guangzhou_headquarters") }}{{ $t("home.guangzhou_headquarters_content") }}</span>
      <span>{{ $t("home.zhanjiang_office") }}{{ $t("home.zhanjiang_office_contentx") }}</span>
      <span>{{ $t("home.zhejiang_branch") }}{{ $t("home.zhejiang_branch_contentx") }}</span>
    </div>
  </div>
</template>

<script>
import http from "@/axios/index.js";
export default {
  name: "aboutus",
  props: {
    msg: String,
  },
  data() {
    return {
      params: {
        page: 1,
        pageSize: 100,
        orders: { sequence: "desc" },
        param: {
          lang: "zh_CN",
        },
      },
      aboutusData: {}, //关于我们数据资料
      contactusData: {}, //联系我们数据资料
    };
  },
  created() {
    if (this.$i18n.locale === "zh") {
      this.params.param.lang = "zh_CN";
    } else if (this.$i18n.locale === "en") {
      this.params.param.lang = "en";
    }
    this.getPageList();
  },
  mounted() {},
  methods: {
    businessStatisClick(){
      this.businessStatis('phoneData')
    },
    getPageList() {
      // 获取联系我们数据资料
      const url = `/frontAboutUs/${this.params.param.lang}`;
      const url2 = `/frontContactUs/${this.params.param.lang}`;
      http
        .get(url)
        .then((res) => {
          if (res.code === "00000") {
            this.aboutusData = res.data;
          }
        })
        .catch((res) => {
          console.log(res);
        });
      http
        .get(url2)
        .then((res) => {
          if (res.code === "00000") {
            this.contactusData = res.data;
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
  },
  watch: {
    "$i18n.locale"(newValue) {
      if (newValue === "zh") {
        this.params.param.lang = "zh_CN";
      } else {
        this.params.param.lang = "en";
      }
      this.getPageList();
    },
  },
};
</script>
<style lang="less" scoped>
.aboutus-content {
  box-sizing: border-box;
  overflow: scroll;
  .title-content {
    padding-top: 9.4rem;
    text-align: center;
    .big-title {
      font-size: 4.2rem;
      font-family: Alibaba PuHuiTi;
      font-weight: 500;
      color: #2b2b2b;
    }

    .small-title {
      font-size: 2.4rem;
      font-family: Alibaba PuHuiTi;
      font-weight: 500;
      color: #1ea5ff;
    }
  }
  .img-introduce-content {
    box-sizing: border-box;
    padding: 3rem 4rem;
    overflow: hidden;
    img {
      width: 67rem;
      border-radius: 2rem;
    }
    p {
      display: inline-block;
      box-sizing: border-box;
      padding: 4.4rem 0;
      font-size: 2.6rem;
      font-family: Alibaba PuHuiTi;
      font-weight: 400;
      color: #2b2b2b;
    }
  }
  .sale-card-content {
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    background: #f5f5f5;
    .card-item {
      position: relative;
      overflow: hidden;
      padding: 2rem;
      // justify-content: space-between;
      box-sizing: border-box;
      margin-top: 4rem;
      width: 68.4rem;
      background: #ffffff;
      border-radius: 2.4rem;
      display: flex;
      align-items: center;
      .card-item-head-img {
        min-width: 16rem;
        max-width: 16rem;
        img {
          width: 100%;
        }
      }
      .card-item-head-text {
        box-sizing: border-box;
        padding-left: 1rem;
        img {
          width: 2.4rem;
        }
        div {
          margin-top: 3rem;
          &:first-child {
            margin-top: unset;
          }
        }
        span {
          margin-left: 2rem;
        }
        .name {
          font-size: 4rem;
          font-family: Alibaba PuHuiTi;
          font-weight: 500;
          color: #4d4d4d;
          white-space: nowrap;
        }
        .phone {
          display: flex;
          font-size: 2rem;
          white-space: nowrap;
          a {
            color: black !important;
          }
        }
        .email {
          display: flex;
          font-size: 2rem;
          white-space: nowrap;
        }
      }
      .card-item-head-code {
        position: absolute;
        top: 20%;
        right: 2rem;
        img {
          min-width: 12rem;
          max-width: 12rem;
        }
      }
    }
  }
  .promotion-content {
    box-sizing: border-box;
    padding-top: 4rem;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    background: #f5f5f5;
    .promotion-item {
      margin-left: 1rem;
      margin-top: 2rem;
      display: flex;
      padding: 2rem;
      flex-direction: column;
      align-items: center;
      // box-sizing: border-box;
      width: 13rem;
      background: #ffffff;
      .promotion-item-title {
        white-space: nowrap;
        font-size: 2rem !important;
        font-family: Alibaba PuHuiTi;
        font-weight: 400;
        color: #646464;
      }
      img {
        width: 13rem;
      }
    }
    .radio-promotion {
      border-radius: 0.8rem 0.8rem 10rem 10rem;
    }
  }
  .aboutus-text {
    display: flex;
    flex-direction: column;
    padding-left: 8rem;
    padding-right: 8rem;
    padding-bottom: 8rem;
    // align-items: center;
    box-sizing: border-box;
    padding-top: 2rem;
    font-size: 2.6rem;
    font-family: Alibaba PuHuiTi;
    font-weight: 400;
    color: #353535;
    background: #f5f5f5;
    text-align: center;
    .home-phone-img-box {
      position: relative;
      margin: 0 auto;
      width: 43.4rem;
      img {
        width: 100%;
      }
      .home-phone-text {
        left: 9rem;
        top: 0.5rem;
        position: absolute;
        color: white;
        font-size: 2.6rem;
        font-family: Alibaba PuHuiTi;
        font-weight: 500;
        color: #ffffff;
      }
    }
    span {
      margin-top: 1rem;
      &:first-child {
        margin-top: unset;
      }
    }
  }
  .aboutus-logo {
    display: flex;
    justify-content: center;
    background: #f5f5f5;
    box-sizing: border-box;
    padding-top: 5.4rem;
    img {
      width: 12.6rem;
      height: 12.6rem;
    }
  }
}
</style>
